module.exports = __webpack_public_path__ + "static/media/racquet.28d35759.svg";